<template>
	<section class="content">
		<div class="row">
			<div class="col-md-12">
				<div class="box box-primary">
					<div class="box-header with-border">
						<h3 class="box-title">
							<b>Detalhes do cadastro</b>
						</h3>
					</div>
					<div class="box-body">
						<form action="">
							<div class="row">
								<div class="col-md-6">
									<div class="form-group">
										<label for="">Unidade de Origem do Cadastro</label>
										<input :value="paciente.nm_unidade" disabled class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<label for="">Cadastrado por</label>
										<input :value="paciente.nm_login" disabled class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-2">
									<div class="form-group">
										<label for="">Status</label>
										<input :value="paciente.st_cidadao | situacao" disabled class="form-control" type="text">
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-4">
									<div class="form-group">
										<label for="">Nome</label>
										<input :value="paciente.nm_pessoa" disabled class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<label for="">Telefone</label>
										<input :value="paciente.nr_telefone" disabled class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<label for="">Cartão SUS</label>
										<input :value="paciente.nr_cartao_sus" disabled class="form-control" type="text">
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-2">
									<div class="form-group">
										<label for="">Data de nascimento</label>
										<input :value="paciente.dt_nascimento | dataFormatada" disabled class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-3">
									<div class="form-group">
										<label for="">Sexo</label>
										<input :value="paciente.tp_sexo == 0 ? 'Masculino' : 'Feminino'" disabled class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-3">
									<div class="form-group">
										<label for="">Estado civil</label>
										<input :value="paciente.st_estado_civil | estadoCivil" disabled class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<label for="">Naturalidade</label>
										<input :value="paciente.nm_naturalidade" disabled class="form-control" type="text">
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-2">
									<div class="form-group">
										<label for="">Tipo de certidão</label>
										<input :value="paciente.tp_certidao | tipoCertidao" disabled class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-2">
									<div class="form-group">
										<label for="">Cartório</label>
										<input :value="paciente.nm_cartorio_certidao" disabled class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-2">
									<div class="form-group">
										<label for="">Livro</label>
										<input :value="paciente.nr_livro_certidao" disabled class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-2">
									<div class="form-group">
										<label for="">Nº da folha</label>
										<input :value="paciente.nr_folha_certidao" disabled class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-2">
									<div class="form-group">
										<label for="">Nº registro</label>
										<input :value="paciente.nr_termo_certidao" disabled class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-2">
									<div class="form-group">
										<label for="">Emissão</label>
										<input :value="paciente.dt_emissao_certidao | dataFormatada" disabled class="form-control" type="text">
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-3">
									<div class="form-group">
										<label for="">CPF</label>
										<input :value="paciente.nr_cpf" disabled class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-3">
									<div class="form-group">
										<label for="">RG</label>
										<input :value="paciente.nr_rg" disabled class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-2">
									<div class="form-group">
										<label for="">Dt. Emissão</label>
										<input :value="paciente.dt_emissao_rg | dataFormatada" disabled class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-2">
									<div class="form-group">
										<label for="">Orgão emissor</label>
										<input :value="paciente.sg_orgao_rg" disabled class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-2">
									<div class="form-group">
										<label for="">UF</label>
										<input :value="paciente.sg_uf_rg" disabled class="form-control" type="text">
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6">
									<div class="form-group">
										<label for="">Nome do responsável</label>
										<input :value="paciente.nm_responsavel" disabled class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-6">
									<div class="form-group">
										<label for="">Ocupação</label>
										<input :value="paciente.nm_ocupacao" disabled class="form-control" type="text">
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6">
									<div class="form-group">
										<label for="">Nome da mãe</label>
										<input :value="paciente.nm_mae" disabled class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-6">
									<div class="form-group">
										<label for="">Nome do pai</label>
										<input :value="paciente.nm_pai" disabled class="form-control" type="text">
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-2">
									<div class="form-group">
										<label for="">CEP</label>
										<input :value="paciente.nr_cep" disabled class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-2">
									<div class="form-group">
										<label for="">Tipo de logradouro</label>
										<input :value="paciente.nm_tipo_logradouro" disabled class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<label for="">Logradouro</label>
										<input :value="paciente.nm_logradouro" disabled class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<label for="">Complemento</label>
										<input :value="paciente.nm_complemento" disabled class="form-control" type="text">
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-2">
									<div class="form-group">
										<label for="">Número</label>
										<input :value="paciente.nr_domicilio" disabled class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-2">
									<div class="form-group">
										<label for="">Bairro</label>
										<input :value="paciente.nm_bairro" disabled class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-3">
									<div class="form-group">
										<label for="">Distrito</label>
										<input :value="paciente.nm_distrito" disabled class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<label for="">Município</label>
										<input :value="paciente.nm_municipio" disabled class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-1">
									<div class="form-group">
										<label for="">UF</label>
										<input :value="paciente.sg_estado" disabled class="form-control" type="text">
									</div>
								</div>
							</div>
						</form>
						<div class="row">
							<div class="col-md-12">
								<router-link tag="a" :to="'/integracao/pacientes'" class="btn btn-default"><span class="fa fa-reply"></span> Voltar</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import axios from 'axios' // Cliente para requisição http

	export default {
		data: () => ({
			paciente: {
				cd_bairro: '',
				cd_cbo: '',
				cd_cidadao: '',
				cd_distrito: '',
				cd_escolaridade: '',
				cd_familia: '',
				cd_logradouro: '',
				cd_municipio: '',
				cd_nacionalidade: '',
				cd_naturalidade: '',
				cd_ocupacao: '',
				cd_pessoa: '',
				cd_religiao: '',
				cd_situacao_familiar_conjugal: '',
				cd_unidade_origem: '',
				cd_usuario: '',
				codigo_fam: '',
				codigo_int: '',
				ds_observacao: '',
				dt_cadastro: '',
				dt_chegada_pais: '',
				dt_emissao_certidao: '',
				dt_emissao_crpee: '',
				dt_emissao_ctps: '',
				dt_emissao_rg: '',
				dt_entrada_brasil: '',
				dt_nascimento: '',
				dt_validade_cartao_sus: '',
				dt_validade_crpee: '',
				gn_pessoa: '',
				id_cidadao: '',
				id_pessoa: '',
				im_pessoa: '',
				lg_enderecamento_familia: '',
				lg_fumante: '',
				nm_apelido: '',
				nm_bairro: '',
				nm_cartorio_certidao: '',
				nm_complemento: '',
				nm_distrito: '',
				nm_email: '',
				nm_estado: '',
				nm_login: '',
				nm_logradouro: '',
				nm_logradouro2: '',
				nm_mae: '',
				nm_municipio: '',
				nm_naturalidade: '',
				nm_pai: '',
				nm_pessoa: '',
				nm_pessoa1: '',
				nm_responsavel: '',
				nm_tipo_logradouro: '',
				nm_unidade: '',
				nm_url: '',
				nr_cartao_crpee: '',
				nr_cartao_sus: '',
				nr_cartao_temp: '',
				nr_cep: '',
				nr_cpf: '',
				nr_ctps: '',
				nr_domicilio: '',
				nr_externo_prontuario: '',
				nr_fax: '',
				nr_folha_certidao: '',
				nr_livro_certidao: '',
				nr_pis_pasep: '',
				nr_rg: '',
				nr_secao_eleitoral: '',
				nr_serie_ctps: '',
				nr_telefone: '',
				nr_termo_certidao: '',
				nr_titulo_eleitoral: '',
				nr_zona_eleitoral: '',
				sg_estado: '',
				sg_orgao_rg: '',
				sg_uf_ctps: '',
				sg_uf_rg: '',
				st_cadastro: '',
				st_cartao_sus: '',
				st_cidadao: '',
				st_estado_civil: '',
				tp_cartao: '',
				tp_cartao_crpee: '',
				tp_certidao: '',
				tp_raca: '',
				tp_sexo: '',
				txt_observacao: '',
			},
		}),
		mounted() {
			this.getPaciente();
		},
		methods: {
			getPaciente() {
				axios.get(`${this.$store.state.serverURI}/api/integracao/pacientes/getById/${this.$route.params.cdPessoa}`, this.$store.getters.getHeaderAuth)
					.then(response => {
						console.log(response.data);
						this.paciente = response.data;
					}).catch((error) => {
						console.log(error);
					});
			},
		},
		filters: {
			estadoCivil: function(value) {
				switch (value) {
					case '':
						return 'NÃO DECLARADO';
					case 0:
						return 'SOLTEIRO(A)';
					case 1:
						return 'CASADO(A)';
					case 2:
						return 'DESQUITADO(A)';
					case 3:
						return 'DIVORCIADO(A)';
					case 4:
						return 'VIUVO(A)';
				}
			},
			tipoCertidao: function(value) {
				switch (value) {
					case 91:
						return 'NASCIMENTO';
					case 92:
						return 'CASAMENTO';
					case 93:
						return 'SEPARAÇÃO / DIVÓRCIO';
				}
			}
		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// form.vue?e9167a2c